(() => {
  if (!document.body.classList.contains('ss-potion-night')) return;
  // The seasonal app injects its leaves after page load. Hide only its artwork.
  const selector = 'img.autumn-leaf, img[src*="snowfall.meetanshi.work/"]';
  function hideAutumn(root) {
    const images = [...(root.querySelectorAll?.(selector) || [])];
    if (root.matches?.(selector)) images.push(root);
    images.forEach(img => {
      img.setAttribute('data-ss-autumn-hidden', '');
      let layer = img;
      while (layer.parentElement && layer.parentElement !== document.body) layer = layer.parentElement;
      if (layer.parentElement !== document.body || layer === img) return;
      const position = getComputedStyle(layer).position;
      if ((position === 'fixed' || position === 'absolute') &&
          !layer.querySelector('a,button,input,select,textarea,form,header,main,nav')) {
        layer.setAttribute('data-ss-autumn-hidden', '');
      }
    });
  }
  hideAutumn(document);
  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') hideAutumn(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) hideAutumn(node); });
    });
  });
  observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['src']});
  const toggle=document.querySelector('.ss-magic-toggle');
  if (!toggle) return;
  let enabled=true;
  try {enabled=sessionStorage.getItem('ss-potion-magic') !== 'off';}catch (_) {}
  function apply() {
    document.body.classList.toggle('ss-magic-off',!enabled);
    toggle.setAttribute('aria-pressed',String(enabled));
    toggle.textContent=enabled ? '✧ Magic on' : '✧ Magic off';
  }
  toggle.addEventListener('click',()=>{enabled=!enabled;apply();try{sessionStorage.setItem('ss-potion-magic',enabled?'on':'off');}catch (_) {}});
  apply();
})();
